export default __webpack_public_path__ + "e37e184c28c9f0265da17f98f542a53d.glb";